<div class="mp-pill" (click)="toggle()">
    <span>{{label}}</span>
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" [class.mp-chevron--open]="open"><path d="M6 9l6 6 6-6" stroke="#0a0a0a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
</div>
<div class="mp-panel" *ngIf="open" (click)="$event.stopPropagation()">
    <div class="mp-year-header">
        <button type="button" class="mp-nav" (click)="prevYear()">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none"><path d="M15 6l-6 6 6 6" stroke="#344054" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
        <span class="mp-year-label">{{draftYear}}</span>
        <button type="button" class="mp-nav" (click)="nextYear()">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none"><path d="M9 6l6 6-6 6" stroke="#344054" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
    </div>
    <div class="mp-months">
        <button type="button" *ngFor="let m of monthNames; let i = index"
            class="mp-month"
            [class.mp-month--active]="i === draftMonth"
            (click)="selectMonth(i)">
            {{m}}
        </button>
    </div>
    <button type="button" class="mp-apply" (click)="apply()">Aplicar</button>
</div>
